import axios from "axios";
import store from "@/store";

export const url = new URL(import.meta.env.VITE_API_URL);

export const HTTP = axios.create({
  baseURL: `${url.origin}${url.pathname}`,
  timeout: 10000,
  withCredentials: true,
});

HTTP.interceptors.request.use(function (config) {
  // if (!store.state.session) return config;
  config.headers["Authorization"] = localStorage.getItem("uuid") || "";
  // config.headers["Authorization"] = `Bearer ${store.state.session.token}`;
  return config;
});

export default HTTP;
